import { useLocation } from "react-router-dom";

export const PRODUCTS = {
  "3dvista": { key: "3dvista", base: "/3dvista", name: "3DVista", auth: "/tdv/auth", plan: "tdv_", unit: "build" },
  giraffe: { key: "giraffe", base: "/giraffe", name: "Giraffe360", auth: "/g360/auth", plan: "g360_", unit: "tour" },
};

export const productFor = (k) => PRODUCTS[k] || PRODUCTS["3dvista"];

export function useProduct() {
  const { pathname } = useLocation();
  return pathname.startsWith("/giraffe") ? PRODUCTS.giraffe : PRODUCTS["3dvista"];
}
